import React from 'react';

import { SVGComponentProps } from './svg.types';

const PrevMediaSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        // fill="none"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.82591 9.84287C4.20842 9.44992 4.20842 8.5485 4.82592 8.15555L14.7966 1.81056C15.4623 1.38691 16.3335 1.86513 16.3335 2.65422V15.3442C16.3335 16.1333 15.4623 16.6115 14.7966 16.1879L4.82591 9.84287Z"
          fill={fill}
        />
        <rect
          width="2.33333"
          height="16.3333"
          rx="1"
          transform="matrix(-1 0 0 1 2.3335 0.833008)"
          fill="#55585E"
        />
      </svg>
    </span>
  );
};

export default PrevMediaSVG;
